export default __webpack_public_path__ + "static/media/pinkBrushStroke.9a5e6e1e.svg";